import React from 'react';

const BS_Collapse = () => {
    return (
        <div>
            <h1>BS_Collapse Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Collapse;
